const filterByProductType = (category: string, productType: string) =>
  category?.toLowerCase() === productType?.toLowerCase();
export default filterByProductType;
